import Axios from "../common/http.js";

/**
 * 小组列表
 */
export const groupList = (params) => {
    return Axios.get("/gorc/admin/group/groupList", { params });
};

/**
 * 保存小组
 */
export const saveGroup = (data) => {
    return Axios.post("/gorc/admin/group/saveGroup", data);
};

/**
 * 删除小组
 */
export const delGroup = (params) => {
    return Axios.get("/gorc/admin/group/delGroup", { params });
};

/**
 * 组任务列表
 */
export const getGroupTaskList = (params) => {
    return Axios.get("/gorc/admin/coin/taskList", { params });
};

/**
 * 保存组任务
 */
export const saveGroupTask = (data) => {
    return Axios.post("/gorc/admin/coin/saveTaskConfig", data);
};

/**
 * 组员列表
 */
export const getGroupUserList = (params) => {
    return Axios.get("/gorc/admin/user/groupUserList", { params });
};

/**
 * 移除组员
 */
export const removeGroupUser = (data) => {
    return Axios.post("/gorc/admin/user/removeGroupUser", data);
};

/**
 * 审核申请列表
 */
export const getAuditList = (params) => {
    return Axios.get("/gorc/admin/group/auditList", { params });
};

/**
 * 审核
 */
export const auditUser = (params) => {
    return Axios.get("/gorc/admin/group/audit", { params });
};
/**
 * 申请列表
 */
export const applyList = (data) => {
    return Axios.post("/gorc/admin/applicant/list", data);
};

/**
 * 审核
 */
export const auditApply = (data) => {
    return Axios.post("/gorc/admin/applicant/audit", data);
};

/**
 * 标签列表
 */
export const getLabelList = (data) => {
    return Axios.post("/gorc/admin/groupLabel/list", data);
};
/**
 * 创建标签
 */
export const createLabel = (data) => {
    return Axios.post("/gorc/admin/groupLabel/create", data);
};

/**
 * 修改标签
 */
export const editLabel = (data) => {
    return Axios.post("/gorc/admin/groupLabel/update", data);
};

/**
 * 删除标签
 */
export const deleteLabel = (data) => {
    return Axios.post("/gorc/admin/groupLabel/delete", data);
};
/**
 * 排序
 */
export const updateGroupOrder = (data) => {
    return Axios.post("/gorc/admin/group/updateGroupOrder", data);
};
